import React from 'react';
import {BrowserRouter as Router , Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MultiStepForm from './components/MultiStepForm';
import UserList from './components/UserList';
import UserDetails from './components/UserDetails';
import Navigation from './components/Navigation';
import PaymentMethodSelect from './components/PaymentMethodSelect';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentFailure from './components/PaymentFailure';
import SearchPage from './components/admin/SearchPage';
import AdminLogin from './components/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminUsers from './components/admin/AdminUsers';
import AdminUserDetails from './components/admin/AdminUserDetails';
import AdminPayments from './components/admin/AdminPayments';
import AdminProfile from './components/admin/AdminProfile';
import StateManagement from './components/admin/StateManagement';
import MatchingManagement from './components/admin/MatchingManagement';
import CityManagement from './components/admin/CityManagement';
import ManageCasteGotra from './components/admin/ManageCasteGotra';
import AIAdminDashboard from './components/admin/AIAdminDashboard';
 // ✅ ADD THIS IMPORT

// Wrapper component to pass query params
const PaymentMethodWrapper = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get('user_id');
    const amount = queryParams.get('amount') || 4000;

    return (
        <PaymentMethodSelect 
            userId={userId}
            amount={amount}
            onBack={() => window.history.back()}
            onSuccess={() => {}}
        />
    );
};

function App() {
    return (
        <Router>
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
                <Navigation />
                <ToastContainer 
                    position="top-right" 
                    autoClose={3000} 
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <Routes>
                    {/* Admin Routes - MUST BE BEFORE OTHER ROUTES */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminLayout />}>
                        <Route index element={<Navigate to="/admin/dashboard" />} />
                        <Route path="dashboard" element={<AdminDashboard />} />
                        <Route path="users" element={<AdminUsers />} />
                        <Route path="users/:id" element={<AdminUserDetails />} />
                        <Route path="payments" element={<AdminPayments />} />
                        <Route path="profile" element={<AdminProfile />} />
                        <Route path="matching" element={<MatchingManagement />} />
                        <Route path="states" element={<StateManagement />} />
                        <Route path="cities" element={<CityManagement />} />
                        <Route path="caste-gotra" element={<ManageCasteGotra />} /> {/* ✅ ADD THIS ROUTE */}
                        <Route path="search" element={<SearchPage />} />
                        <Route path="ai" element={<AIAdminDashboard />} />


                    </Route>

                    {/* Public Routes */}
<Route path="/" element={<MultiStepForm />} />
                    <Route path="/register" element={<MultiStepForm />} />
                    <Route path="/users" element={<UserList />} />
                    <Route path="/user/:id" element={<UserDetails />} />
                    
                    {/* Payment Routes */}
                    <Route path="/payment-method" element={<PaymentMethodWrapper />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/failure" element={<PaymentFailure />} />
                    
                    {/* Catch all - redirect to home */}
<Route path="*" element={<Navigate to="/register" replace />} />                </Routes>
            </div>
        </Router>
    );
}

export default App;